import { AddFeedbackComponent } from './add-feedback/add-feedback.component';
import { ViewFeedbackComponent } from './view-feedback/view-feedback.component';

export const FeedBackRouting = [
    {path: '', redirectTo: 'view-feedback', pathMatch: 'full'},
    {path: 'view-feedback', component: ViewFeedbackComponent},
    {path: 'add-feedback', component: AddFeedbackComponent},
];

export const FeedbackBreadCrumbs = [
    {name:'List',path:'/view-feedback'},
    {name:'Create',path:'/add-feedback'},
    
]